<template>
  <header class="header flex_between" :style="props.style">
    <div class="div_left flex">
      <div class="logo_box flex cp_us" @click="router.push('/')">
        <img class="img_logo" draggable="false" :src="imgObj.commLogo" alt="" />
      </div>
      <a
        class="phone_none"
        v-show="props.options.title"
        target="_blank"
        :href="url + '/home-page'"
        >创作中心</a
      >
      <!-- <span
        class="sp_class cp_us"
        :class="{ sp_strong: searchType == 'class' }"
        v-show="props.options.title"
        @click="clickGoName('smallClass')"
        >小班级</span
      > -->
      <!-- <span
        class="sp_class cp_us"
        :class="{ sp_strong: searchType == 'discover' }"
        v-show="props.options.title"
        @click="clickGoName('discover')"
        >卡片</span
      > -->

      <a class="us_no pc_none" v-show="props.options.title" @click="openApp">
        <i class="key_icon">&#xe745;</i>
        下载APP</a
      >

      <i class="key_icon us_no i_search pc_none" @click="clickGoSerch()"
        >&#xe7a5;</i
      >
    </div>
    <div class="phone_none" v-show="props.options.search">
      <n-input
        ref="refSearch"
        type="text"
        size="large"
        class="input_search"
        placeholder="搜索感兴趣的内容"
        :clearable="true"
        v-model:value="inputValue"
        @keydown.enter="inputSearch()"
        @clear="clearSearch"
      >
        <template #prefix>
          <i class="key_icon i_search">&#xe7a5;</i>
        </template>
      </n-input>
    </div>
    <!-- PC -->
    <div class="div_pc_login phone_none">
      <div v-if="user" class="div_right flex">
        <i
          v-show="props.options.released"
          class="key_icon i_header cp_us"
          @click="refReleasedModal.showModal = true"
          >&#xe74d;</i
        >
        <!-- 消息提示弹框 -->
        <n-popover
          :style="{ borderRadius: '15px', backgroundColor: 'none' }"
          trigger="click"
          placement="bottom-start"
          raw
          :show-arrow="false"
        >
          <template #trigger>
            <div class="div_message" v-show="props.options.message">
              <n-badge
                color="#F07474"
                :value="messageObj.noReadNumber"
                :max="99"
                :offset="[-3, 6]"
              >
                <i class="key_icon i_header cp_us">&#xe74e;</i>
              </n-badge>
            </div>
          </template>
          <div class="div_popover_message">
            <div class="top flex_between">
              <h3 class="us_no">消息通知</h3>
            </div>
            <ul class="ul_table flex">
              <li
                class="cp_us flex"
                ref="refliTable"
                v-for="(v, i) in messageTable"
                :key="v.title"
                @click="clickChangeType(v, i)"
              >
                <span>{{ v.title }}</span>
                <n-badge :value="v.number" color="#FF7B7B" :max="99" />
              </li>
              <div ref="refline" class="div_line"></div>
            </ul>
            <n-scrollbar
              style="height: 70vh; min-height: 300px"
              @scroll="handleScroll"
            >
              <ul class="bot">
                <li v-for="v in messageObj.message" :key="v">
                  <p class="p_title">
                    {{ v.content }}
                    <!-- 通知操作 -->
                    <span class="hover_color_t" @click="clickSetMessage(v)"
                      >点击查看</span
                    >
                  </p>
                  <p class="p_center flex_between">
                    <span class="sp_time us_no">{{ v.createTime }}</span>
                    <span class="sp_read us_no" v-if="v.isread == 1">已读</span>
                    <span class="sp_noread us_no" v-else>未读 </span>
                  </p>
                </li>
                <None
                  v-show="messageObj.message.length == 0"
                  :style="{ width: '100%', marginTop: '120px' }"
                  imgSize="50%"
                  title="暂无通知~"
                ></None>
              </ul>
            </n-scrollbar>
          </div>
        </n-popover>
        <!-- 用户操作弹窗 -->
        <n-popover
          :style="{ borderRadius: '15px', backgroundColor: 'none' }"
          trigger="hover"
          placement="bottom"
          raw
          :show-arrow="false"
        >
          <template #trigger>
            <n-avatar
              class="cp_us"
              round
              :size="28"
              :src="
                user.headimgurl + '?x-oss-process=image/resize,w_100,m_lfit'
              "
            />
          </template>
          <div class="div_popover_user">
            <div class="top flex">
              <n-avatar
                class="cp_us"
                round
                :size="56"
                :src="
                  user.headimgurl + '?x-oss-process=image/resize,w_100,m_lfit'
                "
              />
              <section>
                <h3>{{ user.nickname }}</h3>
                <p>账号ID：{{ user.account }}</p>
              </section>
            </div>
            <hr />
            <ul class="ul_user cp_us">
              <li
                v-for="value in popoverList"
                :key="value.title"
                @click="clickPrope(value.title)"
              >
                <div class="div_br" v-if="value.br"></div>
                <div class="div_list flex" v-else>
                  <i class="key_icon">{{ value.icon }}</i>
                  <span> {{ value.title }}</span>
                  <i class="key_icon i_right">&#xe758;</i>
                </div>
              </li>
              <li class="flex div_list li_out" @click="clickPrope('退出登录')">
                <i class="key_icon">&#xe7af;</i>
                <span>退出登录</span>
              </li>
            </ul>
          </div>
        </n-popover>
      </div>
      <div v-else class="div_right flex">
        <n-button @click="clickLogin()">登录</n-button>
      </div>
    </div>
    <!-- 手机登录 -->
    <div class="div_phone_login pc_none">
      <n-popover
        :style="{ borderRadius: '15px', backgroundColor: 'none' }"
        trigger="click"
        placement="bottom-start"
        raw
        :show-arrow="false"
      >
        <template #trigger>
          <n-avatar
            v-if="user"
            class="cp_us"
            round
            :size="28"
            :src="user.headimgurl"
          />
          <i v-else class="key_icon cp_us i_header">&#xe60b;</i>
        </template>
        <div class="div_proper_phone">
          <li v-if="!user" @click="clickLoginPhone()">登录/注册</li>
          <li v-if="user" @click="clickPrope('我的主页')">我的主页</li>
          <li @click="clickOpenShare()">分享页面</li>
          <li v-if="user" @click="clickPrope('退出登录')">退出登录</li>
        </div>
      </n-popover>
    </div>
    <!-- 发布 -->
    <ReleasedModal ref="refReleasedModal" />
  </header>
  <!-- 分享弹窗 -->
  <ShareModal ref="refShare" />
</template>

<script setup>
import { nextTick, ref, watch } from "vue";
import { useCounterStore } from "@/stores/counter";
import { storeToRefs } from "pinia";
import { unstableFlexRtl, useMessage } from "naive-ui";

import ReleasedModal from "@/components/modal/releasedModal.vue";
import ShareModal from "@/components/modal/shareModal.vue";
import None from "@/components/other/none.vue";

import { logOut } from "@/api/login.js";
import { getMyMessage, readMessage } from "@/api/user.js";
import { countAllNotification } from "@/api/login.js";
import { useRoute, useRouter } from "vue-router";

const store = useCounterStore();
const router = useRouter();
const route = useRoute();
const message = useMessage();
const { user } = storeToRefs(store);

const props = defineProps({
  // 控制顶部内容显示
  options: {
    type: Object,
    default: {
      title: true,
      search: true,
      released: true,
      message: true,
      user: true,
    },
  },
  searchValue: { type: String, default: "" },
  // 搜索类型
  searchType: { type: String, default: "" },
  style: {
    type: Object,
    default: {},
  },
});
const emit = defineEmits(["search"]);
let url = import.meta.env.VITE_APP_URL;
let imgObj = ref({
  commLogo: require("@/assets/image/logo/conbrie-logo.png"),
});
let popoverList = [
  {
    title: "我的主页",
    icon: "\ue7ec",
  },
  // {
  //   br: true,
  // },
  // {
  //   title: "卡片投稿",
  //   icon: "\ue7f0",
  // },
  {
    title: "投稿管理",
    icon: "\ue7f1",
  },
  {
    br: true,
  },
  {
    title: "我的收益",
    icon: "\ue7f3",
  },
  {
    title: "我的订单",
    icon: "\ue7f2",
  },
  {
    title: "去往工作台",
    icon: "\ue7b0",
  },
];

let inputValue = ref("");
let searchType = ref("card");
// 消息
let messageObj = ref({
  noReadNumber: 0,
  allPage: 0,
  loading: false,
  message: [],
});
let mesReqObj = ref({
  current: 1,
  limit: 10,
  type: 0,
});
let messageTable = ref([
  { title: "系统通知", type: 0, number: 0 },
  { title: "我的关注", type: 1, number: 0 },
  { title: "订单通知", type: 2, number: 0 },
]);
//--ref--
let refReleasedModal = ref(null);
let refShare = ref(null);
let refSearch = ref(null);
let refliTable = ref(null);
let refline = ref(null);

// 监听路由变化
watch(
  () => route,
  (newPath) => {
    if (newPath.meta.searchType) {
      searchType.value = newPath.meta.searchType;
    } else {
      searchType.value = "card";
    }
  },
  { deep: true, immediate: true }
);

if (props.options.searchValue != "") inputValue.value = props.searchValue;

if (user.value) {
  getMessage();
}

// ---搜索---
function inputSearch() {
  if (route.name == "searchView") {
    emit("search", inputValue.value);
    router.replace({
      query: {
        text: encodeURIComponent(inputValue.value),
        type: route.query.type,
      },
    });
    return;
  }
  let routeUrl = router.resolve({
    name: "searchView",
    query: {
      text: encodeURIComponent(inputValue.value),
      type: searchType.value,
    },
  }).href;
  window.open(routeUrl, "_blank");
  inputValue.value = "";
  refSearch.value.blur();
}
function clickGoSerch() {
  router.push({
    name: "searchView",
    query: { text: encodeURIComponent(""), type: searchType.value },
  });
}
function clearSearch() {
  if (route.name == "searchView") {
    emit("search", "");
    router.replace({ query: { text: "", type: route.query.type } });
  }
}
// 前往登录页
function clickLogin() {
  let loginUrl = import.meta.env.VITE_LOGIN_URL;
  let currentUrl = window.location.href;
  window.location.replace(
    `${loginUrl}?source=` + encodeURIComponent(currentUrl)
  );
}
// 开启手机登录页
function clickLoginPhone() {
  let loginUrl = import.meta.env.VITE_LOGIN_URL;
  let currentUrl = window.location.href;
  window.location.replace(
    `${loginUrl}?source=` + encodeURIComponent(currentUrl)
  );
}
function clickOpenShare() {
  refShare.value.showModal();
}
function clickPrope(title) {
  switch (title) {
    case "我的主页":
      router.push({ name: "userCenter" });
      break;
    case "卡片投稿":
      router.push({ name: "cardManage" });
      break;
    case "投稿管理":
      router.push({ name: "submissionManage" });
      break;
    case "我的收益":
      // router.push({ name: "earningManage" });
      window.open(url + "/setting/earning-manage", "_blank");
      break;
    case "我的订单":
      // router.push({ name: "ordersManage" });
      window.open(url + "/setting/order-manage", "_blank");
      break;
    case "去往工作台":
      window.open(url + "/home-page", "_blank");
      break;
    case "退出登录":
      logOut().then(() => {
        localStorage.removeItem("userMessage");
        store.getUserMessage().catch(() => {
          message.warning("已退出登录");
          router.go(0);
        });
      });
      break;
  }
}
//--消息提示--
// 获取消息
function getMessage() {
  mesReqObj.value.current = 1;
  getMyMessage(mesReqObj.value).then((res) => {
    messageObj.value = {
      noReadNumber: 0,
      allPage: res.data.pages,
      loading: false,
      message: res.data.records,
    };
    getMessageNumber();
  });
}
function getMessageNumber() {
  countAllNotification().then((res) => {
    messageObj.value.noReadNumber = res.data.communityNum;
    messageTable.value[0].number = res.data.communitySystemNum;
    messageTable.value[1].number = res.data.communityFollowNum;
    messageTable.value[2].number = res.data.communityOrderNum;
  });
}
// 切换消息类型
function clickChangeType(v, i) {
  if (v.type == mesReqObj.value.type) return;
  clickAllRead(mesReqObj.value.type);
  let li = refliTable.value[i];
  refline.value.style.left = li.offsetLeft + "px";
  mesReqObj.value.type = v.type;
  getMessage();
}
// 滚动加载消息
function handleScroll(e) {
  if (messageObj.value.loading) return;
  if (mesReqObj.value.current >= messageObj.value.allPage) return;
  const bottomDistance =
    e.target.scrollHeight - e.target.scrollTop - e.target.clientHeight;
  if (bottomDistance < 100) {
    messageObj.value.loading = true;
    mesReqObj.value.current += 1;
    getMyMessage(mesReqObj.value).then((res) => {
      messageObj.value.message = messageObj.value.message.concat(
        res.data.records
      );
      nextTick(() => {
        messageObj.value.loading = false;
      });
    });
  }
}
// 消息操作
function clickSetMessage(item) {
  switch (mesReqObj.value.type) {
    // 审核通知
    case 0:
      router.push({ name: "submissionManage" });
      break;
    // 我的关注
    case 1:
      router.push({
        name: "filePreview",
        query: { fileType: item.fileType, fileId: item.ccid },
      });
      break;
    // 订单通知
    case 2:
      router.push({
        name: "earningManage",
      });
      break;

    default:
      break;
  }
}
// 标记已读
function clickAllRead(type) {
  readMessage({ type }).then(() => {});
}
function clickGoName(name) {
  router.push({ name: name });
}
function openApp() {
  window.location.href = url + "/download-app";
}
function clickGoToCard() {
  window.open(url + "/deputypage/release-card");
}
defineExpose({ clickLoginPhone, clickOpenShare });
</script>

<style lang='scss' scoped>
.header {
  width: 100%;
  padding: 0px 60px;
  height: 60px;
  position: fixed;
  top: 0px;
  left: 0px;
  z-index: 20;
  background-color: white;
  box-sizing: border-box;
  .div_left {
    .logo_box {
      margin-right: 53px;
      user-select: none;
      img {
        height: 30px;
      }
    }
    a {
      font-weight: 500;
      margin-right: 30px;
      color: #666666;
      // white-space: nowrap;
      > i {
        color: #d0d0d0;
      }
    }
    .sp_class {
      font-weight: 500;
      margin-right: 30px;
      color: #666666;
      white-space: nowrap;
      > i {
        color: #d0d0d0;
      }
    }
    .sp_strong {
      font-weight: 600;
      color: #000000 !important;
    }
  }
  .input_search {
    width: 360px;
    background-color: white;
    border-radius: 10px 10px 10px 10px;
    .i_search {
      font-size: 15px;
      margin-right: 4px;
      color: #111111;
    }
  }
  .div_right {
    .i_header {
      font-size: 24px;
    }
    .div_message {
      margin: 0px 40px;
    }
  }
}
// 消息提示弹框
.div_popover_message {
  width: 366px;
  border-radius: 20px;
  background-color: white;
  .top {
    padding: 20px 32px 10px;
    color: #000000;
    > h3 {
      font-size: 15px;
      color: #222222;
    }
  }
  .ul_table {
    width: calc(100% - 40px);
    height: 40px;
    padding: 4px;
    border-radius: 10px;
    margin: 5px auto 0px;
    background: #f5f6f7;
    box-sizing: border-box;
    position: relative;
    .div_line {
      width: 106px;
      height: 32px;
      position: absolute;
      left: 4px;
      top: 50%;
      border-radius: 10px;
      transform: translateY(-50%);
      background-color: white;
      z-index: 1;
      transition: all 0.25s ease-in-out;
    }
    li {
      flex: 1;
      font-size: 14px;
      padding: 6px 0px;
      border-radius: 10px;
      z-index: 2;
      justify-content: center;
      box-sizing: border-box;
      span {
        margin-right: 2px;
      }
    }
  }
  .bot {
    padding: 0px 18px 25px;
    li {
      width: 100%;
      padding: 10px 14px;
      border-radius: 12px;
      margin-top: 6px;
      box-sizing: border-box;
      &:hover {
        background-color: #f8f8f8;
      }
      .p_title {
        font-size: 14px;
        line-height: 20px;
        color: #333333;
      }
      .p_center {
        margin-top: 8px;
        font-size: 12px;
        .sp_time {
          color: #999999;
        }
        .sp_read {
          color: #d6d6d6;
        }
        .sp_noread {
          color: #d3a5a5;
        }
      }
    }
  }
}
// 用户操作弹窗
.div_popover_user {
  width: 240px;
  background: #ffffff;
  border-radius: 15px;
  .top {
    padding: 20px;
    align-items: flex-start;
    .n-avatar {
      min-width: 56px;
    }
    > section {
      margin-left: 16px;
      h3 {
        font-size: 17px;
        font-weight: 500;
        color: #000000;
      }
      p {
        font-size: 13px;
        margin-top: 6px;
        color: #999999;
      }
    }
  }
  > hr {
    width: calc(100% - 40px);
    margin: 0px auto;
    border: none;
    border-top: 1px solid #dddddd;
  }
  .ul_user {
    padding: 10px;
    .div_list {
      height: 40px;
      padding: 0px 10px;
      line-height: 40px;
      font-size: 16px;
      font-weight: 500;
      border-radius: 8px;
      color: #5b5b5b;
      position: relative;
      i {
        font-size: 16px;
        margin-right: 16px;
        color: #999999;
      }
      .i_right {
        font-size: 12px;
        margin-right: 0px;
        color: #d5d5d5;
        position: absolute;
        top: 50%;
        right: 10px;
        transform: translateY(-50%);
      }
      &:hover {
        background-color: #f6f6f7;
      }
    }
    .div_br {
      height: 1px;
      background-color: #ededed;
      margin: 3px 10px;
    }
    .li_out {
      margin-top: 20px;
      border: 1px solid #f2f2f2;
    }
  }
}
// 更多弹框样式
.ul_more_list {
  width: 124px;
  padding: 15px 10px;
  box-sizing: border-box;
  background: #ffffff;
  box-shadow: 0px 0px 20px 1px rgba(145, 145, 145, 0.2);
  border-radius: 12px 12px 12px 12px;
  li {
    font-size: 15px;
    color: #666666;
    text-align: center;
    margin-bottom: 16px;
    &:last-child {
      margin-bottom: 0px;
    }
  }
}
.pc_none {
  display: none;
}
@media screen and (max-width: 1280px) {
  .header {
    width: 100%;
    padding: 0px 30px;
    height: 60px;
    position: fixed;
    top: 0px;
    left: 0px;
    z-index: 20;
    background-color: white;
    box-sizing: border-box;
    .div_left {
      .logo_box {
        margin-right: 18px;
        img {
          height: 25px;
        }
      }
      a {
        font-size: 14px;
        font-weight: 500;
        margin-right: 20px;
        color: #666666;
        > i {
          color: #d0d0d0;
        }
      }
      .sp_class {
        font-size: 14px;
        font-weight: 500;
        margin-right: 20px;
        color: #666666;
      }
    }
    .input_search {
      width: 180px;
      background-color: white;
      border-radius: 10px 10px 10px 10px;
      font-size: 12px;
      .i_search {
        font-size: 14px;
        margin-right: 4px;
        color: #111111;
      }
    }
    .div_right {
      .i_header {
        font-size: 20px;
      }
      .div_message {
        margin: 0px 20px;
      }
    }
  }
}
@media screen and (max-width: 768px) {
  .header {
    width: 100vw;
    min-width: auto;
    padding: 0rem 0.1rem;
    height: 0.5rem;
    position: fixed;
    top: 0rem;
    left: 0rem;
    z-index: 20;
    background-color: white;
    box-sizing: border-box;
    .div_left {
      .logo_box {
        margin-right: 0.2rem;
        img {
          height: 0.2rem;
        }
      }
      a {
        font-size: 0.12rem;
        font-weight: 500;
        margin-right: 0.15rem;
        color: #666666;
        > i {
          font-size: 0.12rem;
          color: #d0d0d0;
        }
      }
      .sp_class {
        font-size: 0.12rem;
        font-weight: 500;
        margin-right: 0.15rem;
        color: #666666;
      }
      .i_search {
        font-size: 0.14rem;
        margin-right: 0.15rem;
        color: #d0d0d0;
      }
    }
    .div_right {
      .i_header {
        font-size: 0.24rem;
      }
      .div_message {
        margin: 0rem 0.4rem;
      }
    }
    .div_phone_login {
      .i_header {
        font-size: 0.2rem;
      }
    }
  }
  .div_proper_phone {
    width: 1.2rem;
    background-color: white;
    border-radius: 0.08rem;
    padding: 0.02rem;
    box-sizing: border-box;
    li {
      height: 0.4rem;
      line-height: 0.4rem;
      padding: 0rem 0.1rem;
      border-radius: 0.03rem;
      font-size: 0.14rem;
      margin-bottom: 0.05rem;
      user-select: none;
      text-align: center;
      color: #5b5b5b;
      &:hover {
        background-color: #f6f6f7;
      }
      &:last-child {
        margin-bottom: 0rem;
      }
    }
  }
}
</style>